import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { vuetify } from './plugins/vuetify';
import { useProjectStore } from '@/stores/projectStore';

import '@/assets/style.scss'
import '@/assets/StyleMethodHelp.css'

import App from './App.vue';

import mdiVue from 'mdi-vue/v3';
import * as mdijs from '@mdi/js';

import router from './router';
import api from './plugins/axios';

import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css'

import { enterAdvance } from './directives/enterAdvance';


const app = createApp(App);

// Initialize Pinia
const pinia = createPinia();
app.use(pinia);

// Initialize Router
app.use(router);

// Initialize Vuetify
app.use(vuetify);

// Registers all MDI icons globally
app.use(mdiVue, { icons: mdijs });

// Add Axios globally
app.config.globalProperties.$axios = api;

// v-enter-advance: Enter springt in Text- und Zahlenfeldern zum nächsten Feld.
app.directive('enter-advance', enterAdvance);

// ✅ Register Toastify
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: 'top-right',
  theme: 'auto',
});


// Reset project title to ensure the right navbar list is used
router.beforeEach((to, from, next) => {
  const store = useProjectStore()

  if (to.meta?.resetsProjectTitle) {
    store.resetTitle()
  }
  next()
});


// Hide sidebar after every navigation
router.afterEach(() => {
  const store = useProjectStore(pinia); // <-- pass pinia instance

  if (store.sidebarShown) {
    store.hideSidebar();
  }
});


// Wait for router before mounting
await router.isReady();

// Initialize store AFTER CSRF is set (optional but safer)
const store = useProjectStore(pinia);
await store.init();


app.mount('#app');